
































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { v4 } from 'uuid';
import { Spacing } from '../constants';
import TimePicker from '../TimePicker.vue';
import FormError from './FormError.vue';
import FormLabel from './FormLabel.vue';
import FormSection from './FormSection.vue';

const getId = () => `form-id-${v4()}`;

export default defineComponent({
	components: {
		FormSection,
		FormError,
		FormLabel,
		TimePicker,
	},
	props: {
		label: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			default: '',
		},
		errorText: {
			type: [String, Boolean],
			default: '',
		},
		id: {
			type: String,
			default: null,
		},
		spacing: {
			type: String as PropType<Spacing>,
			default: Spacing.WIDE,
		},
		required: Boolean,
		withHelp: Boolean,
		hideErrorField: Boolean,
	},
	setup(props) {
		const computedId = computed(() => (props.id === null ? getId() : props.id));
		const hasError = computed(() => Boolean(props.errorText));
		return {
			computedId,
			hasError,
		};
	},
});
